export default "__VITE_ASSET__9fbe087c__"